export const MOBILE_VISIBLE_PLAYERS = 3;

export const visibleRoomPlayers = <T>(
  list: T[],
  compact: boolean,
  limit = MOBILE_VISIBLE_PLAYERS
) => ({
  visible: compact ? list.slice(0, limit) : list,
  remaining: compact ? Math.max(0, list.length - limit) : 0,
});

// Web-only Rooms grid. These breakpoints must match the
// `.bh-room-list--web` media queries in social.css. Native (Capacitor) and
// <=767px keep the original single-column list untouched.
export const ROOMS_GRID_TABLET_QUERY = '(min-width:768px)';
export const ROOMS_GRID_DESKTOP_QUERY = '(min-width:1200px)';

export const roomListClassName = (native: boolean) =>
  native ? 'bh-room-list' : 'bh-room-list bh-room-list--web';

export const roomGridColumns = ({
  native,
  tablet,
  desktop,
}: {
  native: boolean;
  tablet: boolean;
  desktop: boolean;
}) => {
  if (native || !tablet) return 1;
  return desktop ? 3 : 2;
};

/**
 * Round a viewport-derived card count down to whole grid rows so a page never
 * ends with a ragged, scroll-inducing partial row. Single column is returned
 * unchanged (preserves the mobile/native page size exactly).
 */
export const roomGridPageSize = (size: number, columns: number) =>
  columns <= 1 ? size : Math.max(columns, Math.floor(size / columns) * columns);
